import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';

import { clone } from '../../../core/utils';
import { create, isValid } from '../../../components/form';
import { makeSectionConfig, memberWizardFields } from './memberconfig';

const s:any = {
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 2,
  },
  picker: {
    p: 2,
    border: '1px dashed #c9d5ea',
    borderRadius: 2,
    backgroundColor: '#f8fbff',
  },
  helper: {
    color: '#6b7280',
    fontSize: 13,
  },
  fileMeta: {
    mt: 1.5,
    p: 1.5,
    borderRadius: 2,
    border: '1px solid #e5ecf7',
    backgroundColor: '#ffffff',
  },
};

class DocumentPanel extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  componentDidMount() {
    this.setValid(this.currentData());
  }

  currentData = () => {
    const { record = {}, data = {} } = this.props;
    return { ...record, ...(data.data || {}) };
  };

  formconfig = () =>
    makeSectionConfig('memberdocument', 'Baptism Certificate', memberWizardFields.document);

  setValid = (data: any, documentArg?: any) => {
    const hasFile = !!(documentArg?.file || this.props?.data?.document?.file);
    const hasDocumentData = ['dti', 'dfn', 'pno', 'drl'].some((key) => {
      const value = data?.[key];
      return value !== null && value !== undefined && String(value).trim() !== '';
    });
    const isEmpty = !hasDocumentData && !hasFile;
    const formValid = isValid(this.formconfig(), data, 'add');
    const valid = isEmpty ? true : (formValid && hasFile);
    if (typeof this.props.setValid === 'function') this.props.setValid(valid);
  };

  onChange = (name: any) => (value: any) => {
    const { data = {} } = this.props;
    const newdata = { ...(data.data || {}), [name]: value };
    this.props.setItem('data', 'data', newdata);
    this.setValid(newdata);
  };

  setDocumentFile = (doc: any) => {
    this.props.setItem('data', 'document', doc);
    this.setValid(this.currentData(), doc);
  };

  onFileChange = (event: any) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    const document = {
      file,
      name: file.name,
      size: file.size,
      type: file.type,
      source: 'upload',
    };

    this.setDocumentFile(document);
  };

  onClear = () => {
    this.setDocumentFile(null);
  };

  render() {
    const config = this.formconfig();
    const { classes, extras = {}, data = {} } = this.props;
    const sconfig = clone(config);
    const sdata = sconfig.service;
    const mode = 'edit';
    const document = data.document;

    return (
      <Box sx={{ ...s.root }}>
        {create(mode, sdata, this.currentData(), {}, this.onChange.bind(this), classes, extras)}
        <Box sx={{ ...s.picker }}>
          <Typography variant="subtitle1">Baptism Certificate</Typography>
          <Typography sx={{ ...s.helper, mt: 0.5 }}>
            This step is optional. If you provide baptism details, also upload the certificate document. PDF and image files are supported, up to 10MB.
          </Typography>
          <Box sx={{ mt: 2, display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
            <Button variant="contained" component="label">
              Choose Certificate
              <input
                hidden
                accept=".pdf,image/*,.doc,.docx"
                type="file"
                onChange={this.onFileChange}
              />
            </Button>
            <Button variant="outlined" color="inherit" onClick={this.onClear} disabled={!document?.file}>
              Remove
            </Button>
          </Box>

          {document?.file && (
            <Box sx={{ ...s.fileMeta }}>
              <Typography variant="body2"><strong>Name:</strong> {document.name}</Typography>
              <Typography variant="body2"><strong>Type:</strong> {document.type || 'Unknown'}</Typography>
              <Typography variant="body2"><strong>Size:</strong> {(Number(document.size || 0) / 1024 / 1024).toFixed(2)} MB</Typography>
            </Box>
          )}
        </Box>
      </Box>
    );
  }
}

DocumentPanel.propTypes = {
  classes: PropTypes.object,
};

export default DocumentPanel;
